<sc-flex vertical stretchContent fitHeight class="station-details no-field-space">
  <div>
    <sc-flex>
      <mat-form-field appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.identifier"></sc-dictionary-label>
        </mat-label>
        <input [(ngModel)]="station.identifier" #ctrlIdentifier="ngModel" name="identifier" matInput [required]="true"
          [maxlength]="255" />
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
        </mat-label>
        <input [(ngModel)]="station.name" #ctrlName="ngModel" name="name" matInput [required]="true"
          [maxlength]="255" />
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.name-for-messaging"></sc-dictionary-label>
        </mat-label>
        <input [(ngModel)]="station.nameForMessaging" #ctrlName="ngModel" name="nameForMessaging" matInput
          [required]="true" [maxlength]="255" />
      </mat-form-field>
    </sc-flex>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <div>
    <sc-flex>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
        </mat-label>
        <mat-select [(ngModel)]="station.stationType" #ctrlType="ngModel" name="stationType" [required]="true">
          <mat-option *ngFor="let stationTyp of keys(stationTypes)" [value]="stationTyp">
            <sc-dictionary-label dictionaryKey="tmc-yard.common.enum.station-type.{{stationTypes[stationTyp]}}"></sc-dictionary-label>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.internal"></sc-dictionary-label>
        </mat-label>
        <input [(ngModel)]="station.internal" #ctrlInternal="ngModel" name="internal" matInput [required]="false"
          [maxlength]="255" />
      </mat-form-field>
    </sc-flex>
  </div>
  <sc-content-spacer vertical></sc-content-spacer>
  <mat-form-field appearance="fill">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.common.description"></sc-dictionary-label>
    </mat-label>
    <textarea [(ngModel)]="station.description" #ctrlDescription="ngModel" name="description" matInput
      [required]="false" [maxlength]="255"></textarea>
  </mat-form-field>
  <sc-content-spacer vertical></sc-content-spacer>
  <ng-container *ngIf="station.isWaitingArea()">
    <sc-flex>
      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.yard.entity.station.capacity"></sc-dictionary-label>
        </mat-label>
        <input type="number" [(ngModel)]="station.capacity" #ctrlCapacity="ngModel" name="capacity" matInput
          appPositiveInteger min="0" [required]="true" [maxlength]="4" />
      </mat-form-field>

      <sc-content-spacer></sc-content-spacer>

      <mat-form-field appearance="fill" style="flex-grow:1;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.yard.entity.station.retrievalStrategy"></sc-dictionary-label>
        </mat-label>
        <mat-select [(ngModel)]="station.retrievalStrategy" #ctrlType="ngModel" name="retrievalStrategy">
          <mat-option *ngFor="let retrievalStrategy of possibleRetrievalStrategies" [value]="retrievalStrategy.value">
            <sc-dictionary-label [dictionaryKey]="retrievalStrategy.labelDictionaryKey"></sc-dictionary-label>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </sc-flex>
    <sc-content-spacer vertical></sc-content-spacer>
  </ng-container>
  <mat-form-field appearance="fill">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.externalKey"></sc-dictionary-label>
    </mat-label>
    <input [(ngModel)]="station.externalKey" #ctrlExternalKey="ngModel" name="externalKey" matInput [required]="true"
      [maxlength]="50" [minlength]="1" />
  </mat-form-field>
  <sc-content-spacer vertical></sc-content-spacer>
  <mat-form-field appearance="fill">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.referenceDuration"></sc-dictionary-label>
    </mat-label>
    <input [(ngModel)]="station.referenceDuration" #ctrlReferenceDuration="ngModel" name="referenceDuration" matInput
      appPositiveInteger type="number" min="0" [required]="false" />
  </mat-form-field>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex>
      <mat-checkbox [(ngModel)]="station.suggestNextTransport" name="suggestNextTransport">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.suggestNextTransport"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <mat-checkbox [(ngModel)]="station.disabled" name="disabled">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.disabled"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <mat-checkbox [(ngModel)]="station.opened" name="opened" [disabled]="true">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.opened"></sc-dictionary-label>
      </mat-checkbox>
    </sc-flex>
  </div>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex>
      <mat-checkbox [(ngModel)]="station.plannedTransportAssignmentPossible" name="plannedTransportAssignmentPossible">
        <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.admin.station.planned-transport-assignment-possible"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <div>
        <mat-form-field appearance="fill" style="width: 300px;">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.buffer-zone"></sc-dictionary-label>
          </mat-label>
          <input matInput [(ngModel)]="bufferZoneName" #ctrlBufferZoneId="ngModel" name="bufferZoneId"
            [required]="false" [readonly]="true" [disabled]="!componentsForPlannedAssignmentVisible">
          <sc-action-icon matSuffix (click)="assignBufferZone()" class="small-button assign-button"
            [disabled]="!componentsForPlannedAssignmentVisible" iconClass="fa-sitemap"></sc-action-icon>
        </mat-form-field>
      </div>
    </sc-flex>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.station.transport-creation-profiles"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex-fitting-content vertical>
    <sc-scroll-pane [minHeight]="200">
      <div class="transport-creation-profile-list" cdkDropList (cdkDropListDropped)="dropProfile($event)">
        <div class="draggable-form-box transport-creation-profile" cdkDrag
          *ngFor="let profile of station.transportCreationProfiles">

          <sc-read-only-field class="display-name"
            labelDictionaryKey="tmc-yard.ui.admin.station.transport-creation-profiles.display-name"
            [value]="profile.name">
          </sc-read-only-field>

          <div class="delete-button-wrapper">
            <sc-icon iconClass="fa-trash" (click)="removeTransportCreationProfile(profile)"></sc-icon>
          </div>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <div class="button-wrapper">
          <button class="add-button" mat-flat-button type="button" (click)="addTransportCreationProfile()">
            <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
          </button>
        </div>
      </div>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
